import { render } from "./ManualDownload.vue?vue&type=template&id=41d8b568"
import script from "./ManualDownload.vue?vue&type=script&lang=js"
export * from "./ManualDownload.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__